import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function Pager({
	page,
	pages,
	onPage,
	className,
}: {
	page: number;
	pages: number;
	onPage: (page: number) => void;
	className?: string;
}) {
	const start = Math.max(1, Math.min(page - 2, pages - 4));
	const visiblePages = Array.from({ length: Math.min(5, pages) }, (_, index) => start + index);

	return (
		<nav
			aria-label="Paginação"
			className={cn("flex items-center justify-center gap-1 pt-1", className)}
		>
			<Button
				type="button"
				variant="ghost"
				size="icon"
				aria-label="Página anterior"
				disabled={page <= 1}
				onClick={() => onPage(page - 1)}
			>
				<ChevronLeft />
			</Button>

			<span className="px-3 text-sm tabular-nums text-muted-foreground sm:hidden">
				Página {page} de {pages}
			</span>

			{visiblePages.map((p) => (
				<Button
					key={p}
					type="button"
					variant={p === page ? "default" : "ghost"}
					size="icon"
					className="hidden sm:inline-flex"
					aria-label={`Página ${p}`}
					aria-current={p === page ? "page" : undefined}
					onClick={() => onPage(p)}
				>
					{p}
				</Button>
			))}

			<Button
				type="button"
				variant="ghost"
				size="icon"
				aria-label="Próxima página"
				disabled={page >= pages}
				onClick={() => onPage(page + 1)}
			>
				<ChevronRight />
			</Button>
		</nav>
	);
}
